import { RobotModel } from '@/interfaces'
import { ROBOT_MODELS, UnknownModel } from '.'

export function getRobotModelByName(name: string): RobotModel {
  const model = ROBOT_MODELS.find((model) => model.name === name)
  return model ? model : UnknownModel
}
